import { getTimer } from './getTimer';

export function getDateTimer(value) {
    const data = getTimer(value);
    if (data.d > 0) {
        return data.d + '天';
    }
    if (data.h > 0 && data.d <= 0) {
        return data.h + '小时';
    }
    if (data.m > 0 && data.h <= 0) {
        return data.m + '分钟';
    }
    if (data.s > 0 && data.m <= 0) {
        return data.s + '秒';
    }
}
